import React, { Component, Fragment } from 'react';
import { DocumentNode } from 'graphql';
import { compose } from 'recompose';
import { Trans } from 'react-i18next';
import { Mutation, MutationFunction } from 'react-apollo';
import { ApolloError } from 'apollo-client';

import { UpdateUserProfileMutationFn } from 'api';
import { withErrorHandler, IWithErrorHandler } from 'providers/withErrorHandler';
import { Error, SubmitButton, IUploader } from '../';

interface IProps {
  mutation: DocumentNode;
  onClose: IUploader['onClose'];
  onSave: (mutation: MutationFunction) => void;
}

interface IPropsEnhanced extends IProps, IWithErrorHandler {}

interface IState {
  working: boolean;
}

const enhancers = compose<IPropsEnhanced, IProps>(withErrorHandler);

class Dialog extends Component<IPropsEnhanced, IState> {
  state: IState = {
    working: false,
  };

  handleCompleted = () => {
    const { onClose } = this.props;
    this.setState({ working: false }, onClose);
  };

  handleError = (error: ApolloError) => {
    const { onError } = this.props;
    this.setState({ working: false }, () => onError(error));
  };

  handleSave = (mutationFn: MutationFunction) => () => {
    const { onSave } = this.props;
    this.setState({ working: true }, () => onSave(mutationFn));
  };

  render() {
    const { error, mutation, onErrorClose } = this.props;
    const { working } = this.state;

    return (
      <Fragment>
        <Error contained key={error} message={error} onClose={onErrorClose} />
        <Mutation mutation={mutation} onError={this.handleError} onCompleted={this.handleCompleted}>
          {(mutationFn: UpdateUserProfileMutationFn) => (
            <Fragment>
              <SubmitButton
                working={working}
                text={<Trans i18nKey="common:save" />}
                onClick={this.handleSave(mutationFn)}
              />
            </Fragment>
          )}
        </Mutation>
      </Fragment>
    );
  }
}

export default enhancers(Dialog);
